import { useState } from 'react';
import { getAttendeeList } from '../../../../../api/ApiBooking';

const UseDataAttendeeState = ({ rowPerPage }) => {
    const [bookingId, setBookingId] = useState('');
    const [dataTable, setDataTable] = useState([]);

    const [page, setPage] = useState(1);
    const [total, setTotal] = useState();
    const [sortColumn, setSortColumn] = useState();
    const [sortType, setSortType] = useState();

    const setInitialDataTable = (data) => {
        setDataTable(data.data);
        setPage(1);
        setTotal(data.total);

        setSortColumn();
        setSortType();
    };

    const sortData = (column, type, typeData) => {
        const param = `bookingId=${bookingId}&sort=${type}&offset=0&limit=10`;
        getAttendeeList(param).then((value) => {
            setDataTable(value.data);
            setSortColumn(column);
            setSortType(type);
            setPage(1);
        });
    };

    const changePage = (page, initailData) => {
        const param = `bookingId=${bookingId}&sort=${
            sortType || 'asc'
        }&offset=${(page - 1) * 10}&limit=10`;
        getAttendeeList(param).then((value) => {
            setDataTable(value.data);
            setPage(page);
        });
    };

    return {
        dataTable,
        page,
        total,
        sortColumn,
        sortType,
        rowPerPage,

        setInitialDataTable,
        setBookingId,
        setPage,
        setSortType,
        sortData,
        changePage,
    };
};

export default UseDataAttendeeState;
